/*
 * @Author: your name
 * @Date: 2020-11-15 23:28:32
 * @LastEditTime: 2020-12-25 17:06:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/store/modules/cart.js
 */
import {
  getCartList,
  batchSelect,
  batchDelete,
  updateCart,
  preCheckout,
  checkout,
  checkIdentityIdcard,
  addTCart,
  mallretailspuChoice
} from "@/api/cart";

const state = {
  getCartList: {
    tCartArrayDTO: [
      {
        list: []
      }
    ]
  },
  preCheckout: {
    itemList: [],
    address: {
      isDefault: false
    },
    orderType: 0
  },
  checkout: {},
  mallretailspuChoice: {}
};

const mutations = {
  SET_CARTLIST(state, data) {
    state.getCartList = data;
  },
  SET_BATCHSELECT() {},
  SET_BATCHDELETE() {},
  SET_UPDATECART() {},
  SET_CHECKIDENTITYIDCARD() {},
  SET_ADD_CART() {},
  SET_CHECKED(state, data) {
    // checkout
    state.checkout = data;
  },
  SET_PRECHECKOUT(state, data) {
    // preCheckout
    state.preCheckout = data;
  },
  SET_MALL_CHOICE(state, data) {
    state.mallretailspuChoice = data;
  }
};

const actions = {
  // 购物车列表
  async getCartList({ commit }, { params }) {
    const response = await getCartList(params);
    if (response.code === 1) {
      // console.log(response);
      commit("SET_CARTLIST", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 批量修改购物车选中状态
  async batchSelect({ commit }, { params }) {
    const response = await batchSelect(params);
    if (response.code === 1) {
      commit("SET_BATCHSELECT", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 批量修改购物车选中状态
  async batchDelete({ commit }, { params }) {
    const response = await batchDelete(params);
    if (response.code === 1) {
      commit("SET_BATCHDELETE", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 修改购物车数量
  async updateCart({ commit }, { params }) {
    const response = await updateCart(params);
    if (response.code === 1) {
      commit("SET_UPDATECART", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 预下单接口
  async preCheckout({ commit }, { params }) {
    const response = await preCheckout(params);
    if (response.code === 1) {
      commit("SET_PRECHECKOUT", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject(response);
  },
  // 下单接口
  async checkout({ commit }, { params }) {
    const response = await checkout(params);
    if (response.code === 1) {
      commit("SET_CHECKED", response.data);
      return Promise.resolve(response.data);
    } else return Promise.reject(response);
  },
  // 校验实名认证
  async checkIdentityIdcard({ commit }, { params }) {
    const response = await checkIdentityIdcard(params);
    if (response.code === 1) {
      commit("SET_CHECKIDENTITYIDCARD", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 加入购物车
  async addTCart({ commit }, { params }) {
    const response = await addTCart(params);
    if (response.code === 1) {
      commit("SET_ADD_CART", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  },
  // 购物车选择规格
  async mallretailspuChoice({ commit }, { params }) {
    const response = await mallretailspuChoice(params);
    if (response.code === 1) {
      commit("SET_MALL_CHOICE", response.data);
      return Promise.resolve();
    } else return Promise.reject(response);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
